import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChatbotFunService } from 'src/app/services/chatbot-fun.service';

@Component({
  selector: 'app-service-buttons',
  templateUrl: './service-buttons.component.html',
  styleUrls: ['./service-buttons.component.css']
})
export class ServiceButtonsComponent implements OnInit {
  @Input() buttons: any[] = [];
  @Output() buttonClicked = new EventEmitter<{ value: string; text: string }>();

  constructor(public chatbotFunService: ChatbotFunService) { }

  ngOnInit() {
    console.log('service-buttons ----> called');
  }
  
  buttonImages: { [key: string]: string } = {
    'Book a test drive': 'assets/imgs/list-option1.png',
    'حجز موعد اختبار قيادة': 'assets/imgs/list-option1.png',
    'Sales Inquiry': 'assets/imgs/list-option2.png',
    'استفسار عن المبيعات': 'assets/imgs/list-option2.png',
    'After sales services': 'assets/imgs/list-option3.png',
    'خدمات ما بعد البيع': 'assets/imgs/list-option3.png',
    'Book service appointment': 'assets/imgs/list-option3.png',
    'حجز موعد صيانة': 'assets/imgs/list-option3.png',
    'Branches locations': 'assets/imgs/list-option4.png',
    'مواقع الفروع': 'assets/imgs/list-option4.png',
    'Contact us': 'assets/imgs/list-option5.png',
    'تواصل معنا': 'assets/imgs/list-option5.png',
    'Call back request': 'assets/imgs/list-option5.png',
    'طلب معاودة الاتصال': 'assets/imgs/list-option5.png',
    'Online Conversation': 'assets/imgs/list-option6.png',
    'المحادثة المباشرة': 'assets/imgs/list-option6.png',
    'Personal Info update': 'assets/imgs/Group 257 (1).svg',
    'تحديث البيانات الشخصية': 'assets/imgs/Group 257 (1).svg',
    'Body and Paint': 'assets/imgs/bodyAndPaint.jpg',
    'السمكرة والدهان': 'assets/imgs/bodyAndPaint.jpg'
  };

  onButtonClick(value: string, text: string) {
    this.buttonClicked.emit({ value, text });
  }

}
